(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1371],{

/***/ 38352:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/refleksi/[id]",
      function () {
        return __webpack_require__(95272);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4317);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86010);
/* harmony import */ var _wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(89140);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89004);
/* harmony import */ var _wartek_id_button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54204);
/* harmony import */ var _wartek_id_fe_toolbox__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(72955);
/* harmony import */ var app_PelatihanMandiriPage_components_QueryNotCompleteError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25536);
/* harmony import */ var api_microlearning_useAPIMateri__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47080);
/* harmony import */ var utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7379);
/* harmony import */ var components_EmptyState__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99270);
/* harmony import */ var components_Layout_Desktop_DesktopLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72351);
/* harmony import */ var assets_icons_close_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17436);





















var MINIMUM_REFLECTION_LENGTH = 50;
var isNotOnlyWhitespaceAndMoreThanMinChars = function(str) {
    return str.trim().length > MINIMUM_REFLECTION_LENGTH;
};
var RefleksiPage = function(props) {
    var isDesktopScreenSize = props.isDesktopScreenSize;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), query = ref.query, back = ref.back, isRouterReady = ref.isReady;
    var ref1 = (0,api_microlearning_useAPIMateri__WEBPACK_IMPORTED_MODULE_5__/* .useGetReflection */ .iR)(query.modul, query.id), isSuccess = ref1.isSuccess, isFetchedAfterMount = ref1.isFetchedAfterMount, isError = ref1.isError, reflectionData = ref1.data;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isQueryNotComplete = ref2[0], setIsQueryNotComplete = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), isTrackOpened = ref3[0], setIsTrackOpened = ref3[1];
    var ref4 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useForm */ .cI)({
        mode: "onChange"
    }), register = ref4.register, handleSubmit = ref4.handleSubmit, _formState = ref4.formState, isValid = _formState.isValid, errors = _formState.errors;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isRouterReady && !query.modul) {
            setIsQueryNotComplete(true);
        }
    }, [
        query,
        isRouterReady
    ]);
    var ref5 = (0,api_microlearning_useAPIMateri__WEBPACK_IMPORTED_MODULE_5__/* .usePostRefleksi */ .N_)(query.modul, query.id, {
        onSuccess: function() {
            back();
        }
    }), mutateAsync = ref5.mutateAsync, isSubmittingForm = ref5.isLoading;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isSuccess && !isTrackOpened) {
            (0,utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .GATrackEvent */ .l)({
                eventName: "learning_activity",
                eventParams: {
                    event_trigger: "module_open_reflection",
                    action_type: "open_material_reflection",
                    meta: JSON.stringify({
                        material_id: query.id,
                        module_id: query.modul
                    })
                },
                sendDefaultParams: true
            });
            setIsTrackOpened(true);
        }
    }, [
        isSuccess,
        isTrackOpened,
        query.id,
        query.modul
    ]);
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(data) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .GATrackEvent */ .l)({
                            eventName: "learning_activity",
                            eventParams: {
                                event_trigger: "reflection_save_reflection",
                                action_type: "save_material_reflection",
                                meta: JSON.stringify({
                                    material_id: query.id,
                                    module_id: query.modul
                                })
                            },
                            sendDefaultParams: true
                        });
                        return [
                            4,
                            mutateAsync({
                                answer: data.refleksi
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    if (isQueryNotComplete) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(app_PelatihanMandiriPage_components_QueryNotCompleteError__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
    if (isError) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* .EmptyState */ .ub, {
                title: "Data gagal dimuat",
                description: "Ada kesalahan pada sistem. Silakan coba beberapa saat lagi.",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* .EmptyStateAction */ .Px, {
                    onClick: function() {
                        return window.location.reload();
                    },
                    children: "Muat Ulang"
                })
            })
        });
    }
    // if (isSuccess && isDesktop) {
    //   return (
    //     <DesktopLayout
    //       submenu={
    //         from === 'learning-series' ? (
    //           <ForYou isDesktop={isDesktop} currentId={menuId as string} />
    //         ) : (
    //           <TopicList isDesktop={isDesktop} currentId={menuId as string} />
    //         )
    //       }
    //     >
    //       <>
    //         <Head>
    //           <title>
    //             Pelatihan Mandiri | Refleksi materi {query.materi_name ?? ''}
    //           </title>
    //         </Head>
    //         <div className="flex flex-row">
    //           {query.from && (
    //             <Icon as="i" className="mr-2" onClick={back}>
    //               arrow_back
    //             </Icon>
    //           )}
    //           <div>
    //             <Text className="pb-1">REFLEKSI</Text>
    //             <Text className="pb-3" variant="heading-lg">
    //               {reflectionData?.data?.question}
    //             </Text>
    //           </div>
    //         </div>
    //         <form
    //           className="flex flex-col h-full px-4 pt-[18px] pb-[4.75rem]"
    //           onSubmit={handleSubmit(onSubmit)}
    //           style={{ height: 'calc(100vh - 15em' }}
    //         >
    //           <div className="relative flex-auto mt-3 z-10">
    //             <textarea
    //               className="block h-full w-full border border-subdued focus:ring-1 rounded-lg bg-white"
    //               name="refleksi"
    //               id="refleksi"
    //               cols={30}
    //               rows={1}
    //               defaultValue={reflectionData?.data?.answer}
    //               {...register('refleksi', {
    //                 required: true,
    //                 validate: isNotOnlyWhitespaceAndMoreThanMinChars,
    //               })}
    //               placeholder="Ketik Refleksi Anda di sini"
    //             />
    //           </div>
    //           <div className="left-0 p-4 w-full z-0">
    //             <Button
    //               disabled={!isValid}
    //               type="submit"
    //               className="block w-full h-[44px] leading-[2.75] bg-interactive-default font-bold text-center text-white rounded-lg focus:ring-1 disabled:bg-surface-disabled disabled:text-icon-disabled"
    //               isLoading={isSubmittingForm}
    //             >
    //               Simpan
    //             </Button>
    //           </div>
    //         </form>
    //       </>
    //     </DesktopLayout>
    //   )
    // }
    if (isSuccess && isFetchedAfterMount) {
        var ref6, ref7, ref8;
        var _materi_name;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Desktop_DesktopLayout__WEBPACK_IMPORTED_MODULE_8__/* .WithLayoutListener */ .nc, {
            isDesktop: isDesktopScreenSize,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            "Pelatihan Mandiri | Refleksi materi ",
                            (_materi_name = query.materi_name) !== null && _materi_name !== void 0 ? _materi_name : ""
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(isDesktopScreenSize && "bg-white p-2 rounded-md"),
                    children: [
                        isDesktopScreenSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                                    className: "p-4",
                                    variant: "heading-md",
                                    children: "Cerita Reflektif"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex flex-col h-full px-4 pt-[18px]", isDesktopScreenSize ? "pb-2" : "pb-[4.75rem]"),
                            onSubmit: handleSubmit(onSubmit),
                            style: {
                                height: "calc(100vh - ".concat(isDesktopScreenSize ? "18" : "3.5", "rem")
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex-shrink-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                                        as: "label",
                                        variant: "heading-sm",
                                        htmlFor: "refleksi",
                                        className: "w-full mb-4",
                                        children: reflectionData === null || reflectionData === void 0 ? void 0 : (ref6 = reflectionData.data) === null || ref6 === void 0 ? void 0 : ref6.question
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative flex-auto mt-3 z-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                        className: "block h-full w-full border border-subdued focus:ring-1 rounded-lg bg-white",
                                        name: "refleksi",
                                        id: "refleksi",
                                        cols: 30,
                                        rows: 1,
                                        defaultValue: reflectionData === null || reflectionData === void 0 ? void 0 : (ref7 = reflectionData.data) === null || ref7 === void 0 ? void 0 : ref7.answer
                                    }, register("refleksi", {
                                        required: true,
                                        validate: {
                                            minLength: function(v) {
                                                return isNotOnlyWhitespaceAndMoreThanMinChars(v) || "Jawaban harus minimal ".concat(MINIMUM_REFLECTION_LENGTH, " karakter");
                                            }
                                        }
                                    })), {
                                        placeholder: "Ketik Refleksi Anda di sini (min. 50 karakter)"
                                    }))
                                }),
                                errors.refleksi && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative mt-3 z-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                                        variant: "helper-bold",
                                        color: "critical",
                                        "aria-live": "polite",
                                        children: "".concat((ref8 = errors.refleksi) === null || ref8 === void 0 ? void 0 : ref8.message)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(!isDesktopScreenSize && "absolute bottom-0 p-4", "left-0 pt-4 w-full z-0"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_button__WEBPACK_IMPORTED_MODULE_18__/* .Button */ .z, {
                                        disabled: !isValid,
                                        type: "submit",
                                        className: "block w-full h-[44px] leading-[2.75] bg-interactive-default font-bold text-center text-white rounded-lg focus:ring-1 disabled:bg-surface-disabled disabled:text-icon-disabled",
                                        isLoading: isSubmittingForm,
                                        children: "Simpan"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return null;
};
var PageHeader = function() {
    var back = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().back;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_19__/* .HeaderBar */ .h_, {
        inverse: true,
        fixed: true,
        variant: "default",
        className: "z-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_19__/* .HeaderBarLeftAction */ .l8, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(assets_icons_close_svg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: "stroke-current text-default"
            }),
            onClick: function() {
                return _wartek_id_fe_toolbox__WEBPACK_IMPORTED_MODULE_20__/* .backToApp */ .NU(back);
            }
        })
    });
};
RefleksiPage.layoutOpts = {
    hasHeader: true,
    className: "text-default",
    header: PageHeader,
    enableDesktopLayout: true
};
/* harmony default export */ __webpack_exports__["default"] = (RefleksiPage);


/***/ }),

/***/ 52165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WU": function() { return /* reexport */ format; },
  "z2": function() { return /* reexport */ register; }
});

// UNUSED EXPORTS: cancel, render

;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/lang/en_US.js
var EN_US = ['second', 'minute', 'hour', 'day', 'week', 'month', 'year'];
/* harmony default export */ function en_US(diff, idx) {
    if (idx === 0)
        return ['just now', 'right now'];
    var unit = EN_US[Math.floor(idx / 2)];
    if (diff > 1)
        unit += 's';
    return [diff + " " + unit + " ago", "in " + diff + " " + unit];
}
//# sourceMappingURL=en_US.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/lang/zh_CN.js
var ZH_CN = ['秒', '分钟', '小时', '天', '周', '个月', '年'];
/* harmony default export */ function zh_CN(diff, idx) {
    if (idx === 0)
        return ['刚刚', '片刻后'];
    var unit = ZH_CN[~~(idx / 2)];
    return [diff + " " + unit + "\u524D", diff + " " + unit + "\u540E"];
}
//# sourceMappingURL=zh_CN.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/register.js
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */
/**
 * All supported locales
 */
var Locales = {};
/**
 * register a locale
 * @param locale
 * @param func
 */
var register = function (locale, func) {
    Locales[locale] = func;
};
/**
 * get a locale, default is en_US
 * @param locale
 * @returns {*}
 */
var register_getLocale = function (locale) {
    return Locales[locale] || Locales['en_US'];
};
//# sourceMappingURL=register.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/utils/date.js
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */
var SEC_ARRAY = [
    60,
    60,
    24,
    7,
    365 / 7 / 12,
    12,
];
/**
 * format Date / string / timestamp to timestamp
 * @param input
 * @returns {*}
 */
function toDate(input) {
    if (input instanceof Date)
        return input;
    // @ts-ignore
    if (!isNaN(input) || /^\d+$/.test(input))
        return new Date(parseInt(input));
    input = (input || '')
        // @ts-ignore
        .trim()
        .replace(/\.\d+/, '') // remove milliseconds
        .replace(/-/, '/')
        .replace(/-/, '/')
        .replace(/(\d)T(\d)/, '$1 $2')
        .replace(/Z/, ' UTC') // 2017-2-5T3:57:52Z -> 2017-2-5 3:57:52UTC
        .replace(/([+-]\d\d):?(\d\d)/, ' $1$2'); // -04:00 -> -0400
    return new Date(input);
}
/**
 * format the diff second to *** time ago, with setting locale
 * @param diff
 * @param localeFunc
 * @returns
 */
function date_formatDiff(diff, localeFunc) {
    /**
     * if locale is not exist, use defaultLocale.
     * if defaultLocale is not exist, use build-in `en`.
     * be sure of no error when locale is not exist.
     *
     * If `time in`, then 1
     * If `time ago`, then 0
     */
    var agoIn = diff < 0 ? 1 : 0;
    /**
     * Get absolute value of number (|diff| is non-negative) value of x
     * |diff| = diff if diff is positive
     * |diff| = -diff if diff is negative
     * |0| = 0
     */
    diff = Math.abs(diff);
    /**
     * Time in seconds
     */
    var totalSec = diff;
    /**
     * Unit of time
     */
    var idx = 0;
    for (; diff >= SEC_ARRAY[idx] && idx < SEC_ARRAY.length; idx++) {
        diff /= SEC_ARRAY[idx];
    }
    /**
     * Math.floor() is alternative of ~~
     *
     * The differences and bugs:
     * Math.floor(3.7) -> 4 but ~~3.7 -> 3
     * Math.floor(1559125440000.6) -> 1559125440000 but ~~1559125440000.6 -> 52311552
     *
     * More information about the performance of algebraic:
     * https://www.youtube.com/watch?v=65-RbBwZQdU
     */
    diff = Math.floor(diff);
    idx *= 2;
    if (diff > (idx === 0 ? 9 : 1))
        idx += 1;
    return localeFunc(diff, idx, totalSec)[agoIn].replace('%s', diff.toString());
}
/**
 * calculate the diff second between date to be formatted an now date.
 * @param date
 * @param relativeDate
 * @returns {number}
 */
function date_diffSec(date, relativeDate) {
    var relDate = relativeDate ? toDate(relativeDate) : new Date();
    return (+relDate - +toDate(date)) / 1000;
}
/**
 * nextInterval: calculate the next interval time.
 * - diff: the diff sec between now and date to be formatted.
 *
 * What's the meaning?
 * diff = 61 then return 59
 * diff = 3601 (an hour + 1 second), then return 3599
 * make the interval with high performance.
 **/
function date_nextInterval(diff) {
    var rst = 1, i = 0, d = Math.abs(diff);
    for (; diff >= SEC_ARRAY[i] && i < SEC_ARRAY.length; i++) {
        diff /= SEC_ARRAY[i];
        rst *= SEC_ARRAY[i];
    }
    d = d % rst;
    d = d ? rst - d : rst;
    return Math.ceil(d);
}
//# sourceMappingURL=date.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/format.js


/**
 * format a TDate into string
 * @param date
 * @param locale
 * @param opts
 */
var format = function (date, locale, opts) {
    // diff seconds
    var sec = date_diffSec(date, opts && opts.relativeDate);
    // format it with locale
    return date_formatDiff(sec, register_getLocale(locale));
};
//# sourceMappingURL=format.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/realtime.js



// all realtime timer
var TIMER_POOL = {};
/**
 * clear a timer from pool
 * @param tid
 */
var clear = function (tid) {
    clearTimeout(tid);
    delete TIMER_POOL[tid];
};
// run with timer(setTimeout)
function run(node, date, localeFunc, opts) {
    // clear the node's exist timer
    clear(getTimerId(node));
    var relativeDate = opts.relativeDate, minInterval = opts.minInterval;
    // get diff seconds
    var diff = diffSec(date, relativeDate);
    // render
    node.innerText = formatDiff(diff, localeFunc);
    var tid = setTimeout(function () {
        run(node, date, localeFunc, opts);
    }, Math.min(Math.max(nextInterval(diff), minInterval || 1) * 1000, 0x7fffffff));
    // there is no need to save node in object. Just save the key
    TIMER_POOL[tid] = 0;
    setTimerId(node, tid);
}
/**
 * cancel a timer or all timers
 * @param node - node hosting the time string
 */
function cancel(node) {
    // cancel one
    if (node)
        clear(getTimerId(node));
    // cancel all
    // @ts-ignore
    else
        Object.keys(TIMER_POOL).forEach(clear);
}
/**
 * render a dom realtime
 * @param nodes
 * @param locale
 * @param opts
 */
function render(nodes, locale, opts) {
    // by .length
    // @ts-ignore
    var nodeList = nodes.length ? nodes : [nodes];
    nodeList.forEach(function (node) {
        run(node, getDateAttribute(node), getLocale(locale), opts || {});
    });
    return nodeList;
}
//# sourceMappingURL=realtime.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/index.js
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */



register('en_US', en_US);
register('zh_CN', zh_CN);



//# sourceMappingURL=index.js.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1958,8189,4317,1529,6367,9774,2888,179], function() { return __webpack_exec__(38352); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);